// @vue/component
import ShPopConfirm from '@/components/Helpers/ShPopConfirm';

export default {
  name: 'BlacklistItem',

  components: {
    ShPopConfirm,
  },

  props: {
    blacklistElement: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isElementLoading: false,
      paramsToUpdate: {
        is_blocked: this.blacklistElement.is_blocked || false,
      },
    };
  },

  methods: {
    updateNumber() {
      const params = {
        ...this.paramsToUpdate,
        number: this.blacklistElement.uuid,
      };
      this.$store.dispatch('blacklist/updateNumber', params);
      this.$message({
        title: 'Sukces',
        message: `
          Zmieniono status numeru 
          ${this.blacklistElement.blocked_num} 
          na ${this.paramsToUpdate.is_blocked ? 'zablokowany' : 'odblokowany'} 
        `,
        type: 'success',
      });
    },
    async removeNumber() {
      const params = {
        number: this.blacklistElement.uuid,
      };
      this.isElementLoading = true;
      await this.$store.dispatch('blacklist/removeNumber', params);
      this.$message({
        title: 'Sukces',
        message: 'Numer został usunięty z Czarnej Listy',
        type: 'success',
      });
      this.isElementLoading = false;
    },
  },
};
